import { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Spin } from 'antd';
import FormularioPage from './pages/FormularioPage';
import HomologacaoPage from './pages/HomologacaoPage';
import HomologacoesListPage from './pages/HomologacoesListPage';
import HomologacaoDetalhesPage from './pages/HomologacaoDetalhesPage';
import HomologacaoRouterPage from './pages/HomologacaoRouterPage';
import HomologacaoHistoricoPage from './pages/HomologacaoHistoricoPage';
import ProcuracaoPage from './pages/ProcuracaoPage';
import AnexosPage from './pages/AnexosPage';
import LoginPage from './pages/LoginPage';
import { useAuthStore } from './store/authStore';

export default function App() {
  const bootstrapFromCookie = useAuthStore((s) => s.bootstrapFromCookie);
  const bootstrapped = useAuthStore((s) => s.bootstrapped);

  // Tenta detectar usuário logado via cookie .grupomultiluz.com.br assim que
  // o app monta. Roda silenciosamente: se houver cookie, popula o store sem
  // mostrar tela de login (caso típico dentro do iframe Pipefy).
  useEffect(() => {
    bootstrapFromCookie();
  }, [bootstrapFromCookie]);

  if (!bootstrapped) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#f5f5f5' }}>
        <Spin />
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/formulario" element={<FormularioPage />} />
      <Route path="/procuracao" element={<ProcuracaoPage />} />
      <Route path="/anexos/cliente/:clienteId" element={<AnexosPage />} />
      <Route path="/anexos" element={<AnexosPage />} />
      <Route path="/formulario/:id" element={<FormularioPage />} />
      <Route path="/homologacoes/:clienteId" element={<HomologacoesListPage />} />
      {/* Rota principal: recebe clienteId e decide pra onde ir */}
      <Route path="/homologacao/cliente/:clienteId" element={<HomologacaoRouterPage />} />
      <Route path="/homologacao/novo/:clienteId" element={<HomologacaoPage />} />
      <Route path="/homologacao/detalhes/:id" element={<HomologacaoDetalhesPage />} />
      <Route path="/homologacao/historico/:id" element={<HomologacaoHistoricoPage />} />
      <Route path="/homologacao/:id" element={<HomologacaoPage />} />
      <Route path="/homologacao" element={<HomologacaoPage />} />
      <Route path="*" element={<Navigate to="/formulario" replace />} />
    </Routes>
  );
}
